import React, { useState, useEffect } from 'react';
import { Cookie } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);
  const location = useLocation();

  // Don't show on admin pages
  const isAdminPage = location.pathname.startsWith('/admin');

  useEffect(() => {
    // Don't show on admin pages
    if (isAdminPage) return;
    
    // Check if user has already accepted/declined cookies
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      // Small delay before showing banner for better UX
      const timer = setTimeout(() => setShowBanner(true), 1500);
      return () => clearTimeout(timer);
    }
  }, [isAdminPage]);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div 
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:max-w-sm z-[9999] animate-slide-up"
      style={{ animation: 'slideUp 0.3s ease-out' }}
    >
      <style>
        {`
          @keyframes slideUp {
            from {
              transform: translateY(100%);
              opacity: 0;
            }
            to {
              transform: translateY(0);
              opacity: 1;
            }
          }
        `}
      </style>
      <div className="bg-[#2d232e] rounded-xl shadow-2xl overflow-hidden">
        <div className="p-4">
          {/* Header */}
          <div className="flex items-center gap-2 mb-2">
            <Cookie className="w-4 h-4 text-[#36827f]" />
            <span className="text-sm font-semibold text-white">Cookie Notice</span>
          </div>
          
          {/* Content */}
          <p className="text-white/70 text-xs leading-relaxed mb-4">
            We use essential cookies to ensure our website works properly. We don't use tracking or advertising cookies.{' '}
            <Link to="/privacy" className="text-[#36827f] hover:underline">
              Learn more
            </Link>
          </p>
          
          {/* Buttons */}
          <div className="flex items-center gap-2">
            <button
              onClick={handleDecline}
              className="flex-1 px-4 py-2 text-xs font-medium text-white/70 hover:text-white hover:bg-white/10 rounded-lg transition-colors"
              data-testid="cookie-decline-btn"
            >
              Decline
            </button>
            <button
              onClick={handleAccept}
              className="flex-1 px-4 py-2 text-xs font-semibold text-white bg-[#36827f] hover:bg-[#2d6f6c] rounded-lg transition-colors"
              data-testid="cookie-accept-btn"
            >
              Accept
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
